import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/play.png'


const _withScopeId = n => (_pushScopeId("data-v-5061af7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "play" }

import { onMounted, reactive, ref } from "vue";
import CheckType from "@/utils/CheckType";

export default /*#__PURE__*/_defineComponent({
  __name: 'Video',
  props: {
  item: {
    type: [Object],
  },
  height: {
    type: Number,
  },
},
  setup(__props) {

const props = __props;


const options = reactive({
  width: "70rem", //播放器高度
  height: "40rem", //播放器高度
  color: "#409eff", //主题色
  title: "", //视频名称
  src: "", //视频源
  muted: false, //静音
  webFullScreen: false,
  speedRate: ["0.75", "1.0", "1.25", "1.5", "2.0"], //播放倍速
  autoPlay: true, //自动播放
  loop: false, //循环播放
  mirror: false, //镜像画面
  volume: 0.3, //默认音量大小
  control: true, //是否显示控制
});
// 视频地址
const videoImg = ref("");
// 视频预览弹窗 value
const centerDialogVisible = ref(false);
const play = (url: string) => {
  options.src = url;
  centerDialogVisible.value = true;
};
const DestructionDialog = () => (options.src = "");
onMounted(() => getVideoFrame(CheckType.isImg(props.item.link), 1));
//第一帧图片
const getVideoFrame = (videoUrl, frames): string | void => {
  const video = document.createElement("video");
  video.width = 200;
  video.height = 200;
  video.src = CheckType.isImg(videoUrl);
  video.currentTime = (1 / 60) * frames;
  video.setAttribute("crossOrigin", "anonymous");
  video.oncanplay = () => {
    const oCanvas = document.createElement("canvas");
    oCanvas.width = video.width;
    oCanvas.height = video.height;
    oCanvas
      .getContext("2d")
      .drawImage(video, 0, 0, video.width, oCanvas.height);
    videoImg.value = oCanvas.toDataURL("image/png");
  };
};

return (_ctx: any,_cache: any) => {
  const _component_vue3VideoPlay = _resolveComponent("vue3VideoPlay")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      class: "video",
      style: _normalizeStyle(`height:${props.height}rem;`),
      src: videoImg.value,
      alt: ""
    }, null, 12, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (play(_unref(CheckType).isImg(props.item.link))))
      })
    ]),
    _createVNode(_component_el_dialog, {
      class: "s-dialog",
      modelValue: centerDialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((centerDialogVisible).value = $event)),
      onClose: DestructionDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vue3VideoPlay, _normalizeProps(_guardReactiveProps(options)), null, 16)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})